/**
 * Os Super Admins (ADR-0025): quem tem o papel global, e como ele é dado e
 * tirado. Só um Super Admin chama estas rotas, e ninguém tira o papel de si.
 */

import { z } from 'zod';
import { IdSchema } from './comum.js';
import { InstanteSchema } from './valores.js';

/** Um Super Admin ativo: quem é, desde quando, e quem deu o papel. */
export const SuperAdminSchema = z
  .object({
    pessoa: z.object({ id: IdSchema, nome: z.string(), email: z.string() }).strict(),
    concedido_em: InstanteSchema,
    /** Nulo no primeiro Super Admin, gravado direto no banco (runbook). */
    concedido_por: z.object({ id: IdSchema, nome: z.string() }).strict().nullable(),
  })
  .strict();

export type SuperAdmin = z.infer<typeof SuperAdminSchema>;

export const SuperAdminsSchema = z.object({ itens: z.array(SuperAdminSchema) }).strict();

export type SuperAdmins = z.infer<typeof SuperAdminsSchema>;

/**
 * Dar o papel a uma pessoa pelo e-mail. Ela precisa existir no CliqCRM: o papel
 * é da conta, e a conta nasce no primeiro convite.
 */
export const ConcederSuperAdminSchema = z
  .object({ email: z.string().trim().email().max(320) })
  .strict();

export type ConcederSuperAdmin = z.infer<typeof ConcederSuperAdminSchema>;
